export default __webpack_public_path__ + "static/media/pictogramBusinessCashFlow40.be3ab121.svg";